import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { observable, action } from 'mobx';
import Axios from 'axios';
import Card from '../Card/Card';
import { Text, View, Whitespace } from '../../../components_new/common';
import { getp } from '../../../helpers/getProp';

@observer
class ManageCards extends Component {
  @observable cards = [];
  @observable default = {};
  @observable adding = false;
  @observable loading = true;
  @observable others = false;
  @observable selected = null;

  async componentDidMount() {
    const sources = await Axios.get('/api/stripe/mycards').catch(err => {
      console.log('Getting cards err', err);
    });

    if (getp(sources, 'data.sources.data')) {
      this.updateSources(sources.data);
    } else {
      this.adding = true;
      this.loading = false;
    }
  }

  @action.bound
  updateSources(sources) {
    if (!sources) {
      this.loading = false;
      return;
    }
    this.cards = sources.sources.data;
    this.default = this.cards.filter(x => x.id === sources.defaultSource)[0];
    this.loading = false;

    const { select } = this.props;
    if (this.default) {
      this.selected = this.default;
      this.default.selected = true;
      if (select) {
        select(this.default.id);
      }
    }
  }

  @action.bound
  onSelected(card) {
    const { select } = this.props;
    if (select) {
      select(card.id);
    }
    if (this.selected) {
      this.selected.selected = false;
    }
    if (card) {
      this.selected = card;
      this.selected.selected = true;
      this.others = false;
    }
  }

  @action.bound
  onNewCard(newCard) {
    this.adding = false;
    this.cards.push(newCard);
    this.onSelected(newCard);
  }

  render() {
    return (
      <View className="f f-rows">
        <View
          if={!this.loading && (!this.default || this.adding)}
          className="f f-rows"
        >
          <Card onSave={this.onNewCard} />
          <Whitespace smaller2 />
          <View className="f f-columns f-between-center" if={this.adding}>
            <Text link clickable onClick={() => (this.adding = false)}>
              Cancel add new card
            </Text>
          </View>
        </View>
        <View if={this.selected && !this.others && !this.adding}>
          <ExistingCard card={this.selected} />
          <Whitespace smaller2 />
          <View className="f f-columns f-between-center">
            <View if={this.cards.length > 1}>
              <Text link clickable onClick={() => (this.others = true)}>
                Select a different card
              </Text>
            </View>
            <Text link clickable onClick={() => (this.adding = true)}>
              Add a new card
            </Text>
          </View>
        </View>
        <View className="f f-columns f-wrap" if={this.others}>
          {this.cards.map(card => (
            <ExistingCard card={card} onSelected={this.onSelected} />
          ))}
          <Whitespace smaller2 />
          <View className="f f-columns f-between-center m-l" if={this.others}>
            <Text link clickable onClick={() => (this.others = false)}>
              Cancel
            </Text>
          </View>
        </View>
      </View>
    );
  }
}

export default ManageCards;

function ExistingCard(props) {
  const { card } = props;
  return (
    <View
      className="p-mxx b-1 b-coolGrayLight brad-m pointer"
      onClick={() => props.onSelected && props.onSelected(card)}
    >
      <Text clickable t-l>
        {card.name}
      </Text>
      <View className="f f-columns f-between-center">
        <Text clickable mr={3} t-s>
          Ending in{' '}
          <Text inline t-m>
            {card.last4}
          </Text>
        </Text>
        <Text clickable>{card.brand}</Text>
      </View>
    </View>
  );
}



// WEBPACK FOOTER //
// ./src/components/Booking/Payment/ManageCards.js